import $ from 'jquery';
import '../../../node_modules/svgxuse/svgxuse.js';
import '../../../node_modules/core-js/';
import AOS from 'aos';
import '../../../node_modules/aos/dist/aos.css';

import Swiper, { Navigation, Pagination, Autoplay, Lazy, Thumbs, EffectCoverflow } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Lazy, Thumbs, EffectCoverflow]);
import 'swiper/swiper-bundle.css';
import './materializecss.js';

// ---------------------------------------------------------
// Custom Functions for Front-End
// ---------------------------------------------------------

$(document).ready(function() {
  // slider Top page
  if($('.jsCarouselTop').length) {
    let elems = document.querySelectorAll('.jsCarouselTop .carousel');
    let instances = M.Carousel.init(elems);
    let wWidth = $(window).width();
    let timeCarouselInstances, setAutoPlay;
    let timeDelay = 3000;
  
    function carouselInstances() {
      $('.jsCarouselTop .indicators').remove();
      if(wWidth > 1133) {
        instances = M.Carousel.init(elems, {
          indicators: true,
          shift: -65,
          numVisible: 5,
          padding: -560,
          dist: -35,
          fullWidth: false,
        });
      } else if(wWidth <= 1133 && wWidth > 750) {
        instances = M.Carousel.init(elems, {
          indicators: true,
          padding: -420,
          shift: -40,
          dist: -20,
          numVisible: 5,
          fullWidth: false,
        });
      } else if(wWidth <= 750) {
        instances = M.Carousel.init(elems, {
          indicators: true,
          shift:0,
          numVisible: 1,
          padding: 0,
          dist: 0,
          fullWidth: true,
          duration: 150,
        });
      }
    }

    $(window).on('load resize' ,function() {
      wWidth = $(window).width();
      clearTimeout(timeCarouselInstances);
      timeCarouselInstances = setTimeout(carouselInstances, 500);
    })
    if(instances[0]) {
      $('.carousel-wrapper').addClass('exist');
    } else {
      $('.carousel-wrapper').removeClass('exist')
    }
    // set autoplay
    let slideToNext = function(){
      instances[0].next();
    }
    setAutoPlay = setInterval(slideToNext, timeDelay);
    // next/prev
    $('.jsCarouselTop .jsNext').on('click', function() {
      clearInterval(setAutoPlay);
      instances[0].next();
      setAutoPlay = setInterval(slideToNext, timeDelay);
    })
    $('.jsCarouselTop .jsPrev').on('click', function() {
      clearInterval(setAutoPlay);
      instances[0].prev();
      setAutoPlay = setInterval(slideToNext, timeDelay);
    })
  }

  var body = $("body");
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    body.addClass('ieMode');
  }

  // btn menu
  $('.btnMenu').click(function() {
    $(this).toggleClass('active');
    $('html').toggleClass('noScroll');
    $('.navBlock').toggleClass('active');
    $('#header').toggleClass('fixedNav');
    $('.showBox').hide();
  });
  $('.jsClose').click(function() {
    $('.btnMenu').trigger('click');
  });

  // page to top
  $(document).on('click', '.jsPageTop', function(e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 0
    }, 500);
  });

  $(window).on('load scroll', function() {
    if ($(this).scrollTop() > 100) {
      $('.jsPageTop').fadeIn();
    } else {
      $('.jsPageTop').fadeOut();
    }
    if ($('.keyv').length) {
      if ($(this).scrollTop() > $('.headerKeyvBox').outerHeight()) {
        $('.firstView').removeClass('firstView');
        $('#contents').css('padding-top', '');
      }
    }
  });

  // aos
  AOS.init({
    offset: 10,
    duration: 500,
    easing: 'ease-in-out',
    delay: 50,
    mirror: 'true',
    once: 'false',
    anchorPlacement: 'top-center'
  });
  // animation text
  document.querySelectorAll('.animatedTxt').forEach((i) => {
    if (i) {
      const observer = new IntersectionObserver((entries) => {
        observerCallback(entries, observer, i)
      }, { threshold: 0 });
      observer.observe(i);
    }
  })

  document.querySelectorAll('.stickerAnimated').forEach((i) => {
    if (i) {
      const observer = new IntersectionObserver((entries) => {
        observerCallback(entries, observer, i)
      }, { threshold: 0 });
      observer.observe(i);
    }
  })

  const observerCallback = (entries, observer, header) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('-visible');
      } else {
        entry.target.classList.remove('-visible');
      }
    });
  };

  // bg ie
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    $('.jsBgIE').each(function() {
      var $this = $(this),
        url = 'url(' + $this.find('img').attr('src') + ')';
      $this.css({
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': '50% 50%',
        'background-image': url
      });
      $this.children('img, picture').hide();
    });
  }
  // show search box
  $('.jsShowSearch').on('click', function(e) {
    e.preventDefault();
    $(this).hide();
    $(this).parents('.searchBlock').find('.searchBox').slideDown();
  })
  // js check all
  $(".jsCheckAll").on("click", function() {
    var checkAll = !$(this)
      .siblings()
      .is(":checked"),
      listCheckbox = $(this)
      .parents(".inputItem")
      .next(".jsChecked")
      .find('input[type="checkbox"]');
    if (checkAll) {
      listCheckbox.each(function() {
        $(this).prop("checked", true);
      });
    } else {
      listCheckbox.each(function() {
        $(this).prop("checked", false);
      });
    }
  });
  $('.jsChecked input[type="checkbox"]').on("change", function() {
    var listCheckbox = $(this)
      .parents(".jsChecked")
      .find('input[type="checkbox"]'),
      count = 0;
    listCheckbox.each(function() {
      if ($(this).prop("checked")) {
        count++;
      }
    });
    if (count == listCheckbox.length) {
      $(this).parents(".jsChecked").prev(".inputItem").find('.jsCheckAll')
        .siblings()
        .prop("checked", true);
    } else {
      $(this).parents(".jsChecked").prev(".inputItem").find('.jsCheckAll')
        .siblings()
        .prop("checked", false);
    }
  });
  // tab
  $(".tab a").click(function(e) {
    var elm = $(this);
    elm.parents(".infoBox")
      .next()
      .children().find(".tabBox")
      .hide();
    $(this.hash).show();
    e.preventDefault();
  });

  $(".tab01 a").on('click', function(e) {
    var elm = $(this);
    if (!elm.hasClass("active")) {
      elm.siblings().removeClass("active");
      elm.addClass("active");
      elm.parents(".tab01").next().children(".tabBox").hide();
      $(this.hash).fadeIn();
    }
    e.preventDefault();
  });

  $(".jsNavTab a").on('click', function(e) {
    let ele = $(this),
      eleHref = ele.attr('href'),
      eleID = ele.attr('data-id');
    window.location.hash = eleHref;
    if (!ele.hasClass("active")) {
      ele.siblings().removeClass("active");
      ele.addClass("active");
      ele.parents(".jsNavTab").next().children(".tabBox").hide();
      $(eleID).fadeIn();
    }
    e.preventDefault();
  });

  if($('#jsAdmissionGuide').length) {
    $(window).on('resize load' ,function() {
    winWidth = $(window).width();
      if(winWidth < 768) {
        $(".jsTabSp a").on('click', function(e) {
          var elm = $(this),
          elmHref = elm.attr('href');
          if (!elm.hasClass("active")){
              elm.siblings().removeClass("active");
              elm.addClass("active");
              elm.parents(".jsTabSp").next().find(".jsTabBox").hide();
                $('*[data-id = "' + elmHref + '"]').fadeIn();
            }
          e.preventDefault();
        });
      }
    });
  }

  // anchor link
  $('.jsAnchor, .jsAnchorBox a').click(function(e) {
    var anchorId = $(this).attr('href');
    if (anchorId != '#') {
      if (winWidth > 767) {
        var offTop = $(anchorId).offset().top - headerHeight;
        $('body, html').animate({
          scrollTop: offTop
        }, 500);
      } else {
        $('#header').addClass('hFixedDown');
        var offTop = $(anchorId).offset().top - headerHeight;
        $('body, html').animate({
          scrollTop: offTop
        }, 500);
      }
    }
    e.preventDefault();
  });
  $('.jsAnchor01').click(function(e) {
    var anchorId = $(this).attr('href');
    if (anchorId != '#') {
      var offTop = $(anchorId).offset().top - headerHeight;
      $('body, html').animate({
        scrollTop: offTop
      }, 500);
    }
    e.preventDefault();
  });
  $('.jsAnchor02').click(function(e) {
    var anchorId = $(this).data('id');
    if (anchorId != '#') {
      if (winWidth > 767) {
        var offTop = $(anchorId).offset().top - headerHeight - 70;
        $('body, html').animate({
          scrollTop: offTop
        }, 500);
      } else {
        var offTop = $(anchorId).offset().top;
        $('body, html').animate({
          scrollTop: offTop - headerHeight - 5
        }, 500);
      }
    }
    e.preventDefault();
  });
  $('.jsAnchor03').click(function(e) {
    var anchorId = $(this).attr('href');
    if (anchorId != '#') {
      var offTop = $(anchorId).offset().top - headerHeight - $('.jsFixed').outerHeight();
      if (window.location.pathname == '/experience/') {
        if (winWidth < 767) offTop = $(anchorId).offset().top - headerHeight;
      }
      $('body, html').animate({
        scrollTop: offTop
      }, 500);
    }
    e.preventDefault();
  });
  $('.jsAnchor04').click(function(e) {
    var anchorId = $(this).attr('href');
    if (anchorId != '#') {
      var offTop = $(anchorId).offset().top - headerHeight - 70;
      $('body, html').animate({
        scrollTop: offTop
      }, 500);
    }
    e.preventDefault();
  });
  $('.jsAnchor05').click(function(e) {
    var anchorId = $(this).attr('href');
    if (anchorId != '#') {
      if (winWidth > 767) {
        var offTop = $(anchorId).offset().top - headerHeight - $('.faqSearchBox ').outerHeight() - 5;
        $('body, html').animate({
          scrollTop: offTop
        }, 500);
      } else {
        $('#header').addClass('hFixedDown');
        var offTop = $(anchorId).offset().top - headerHeight - $('.faqSearchBox ').outerHeight() - 5;
        $('body, html').animate({
          scrollTop: offTop
        }, 500);
      }
    }
    e.preventDefault();
  });
  $('.jsAnchor06').click(function(e) {
    // $(this).siblings().removeClass('active');
    // $(this).addClass('active');
    var anchorId = $(this).attr('href');
    if (anchorId != '#') {
      var offTop = $(anchorId).offset().top - $('.navCommuniSec').outerHeight();
      $('body, html').animate({
        scrollTop: offTop
      }, 500);
    }
    e.preventDefault();
  });
  //
  var winWidth = $(window).width(),
    headerHeight = $('#header').outerHeight();
  $(window).resize(function() {
    winWidth = $(window).width();
    headerHeight = $('#header').outerHeight();
  });

  var position = $(window).scrollTop();

  function scrollHeader() {
    if (!$('.headerForm').length) {
      if ($(window).width() > 767) {
        var heightNote = $('.noteBox').innerHeight(),
          prevScroll = $(document).scrollTop();
        if (heightNote > 0) {
          if (prevScroll > heightNote) {
            $('#header').addClass('hFixed');
          } else {
            $('#header').removeClass('hFixed');
          }
        } else {
          if (prevScroll > 10) {
            $('#header').addClass('hFixed');
          } else {
            $('#header').removeClass('hFixed');
          }
        }
      } else {
        var heightNote = $('.noteBox').innerHeight(),
          prevScroll = $(document).scrollTop();
        $('#header').removeClass('hFixed');
        if (heightNote > 0) {
          if (prevScroll > heightNote) {
            var scroll = $(window).scrollTop();
            if (scroll > position) {
              $('#header').removeClass('hFixedUp').addClass('hFixedDown');
            } else {
              $('#header').removeClass('hFixedDown').addClass('hFixedUp');
            }
            position = scroll;
          } else {
            $('#header').removeClass('hFixedUp').removeClass('hFixedDown');
          }
        } else {
          if (prevScroll > 10) {
            var scroll = $(window).scrollTop();
            if (scroll > position) {
              $('#header').removeClass('hFixedUp').addClass('hFixedDown');
            } else {
              $('#header').removeClass('hFixedDown').addClass('hFixedUp');
            }
            position = scroll;
          } else {
            $('#header').removeClass('hFixedUp').removeClass('hFixedDown');
          }
        }
      }
    }
  }

  function scrollNavCommuni() {
    if ($('.jsNavCommuni').length) {
      if ($(window).width() > 767) {
        var prevScroll = $(document).scrollTop();
          if (prevScroll > 10) {
            $('.navCommuniSec').addClass('nFixed');
          } else {
            $('.navCommuniSec').removeClass('nFixed');
          }
        var scrollPosition = $(window).scrollTop();
        $(".secContrl").each(function () {
            var sectionTop = $(this).offset().top -  $('.navCommuniSec').outerHeight() - 10;
            var sectionBottom = sectionTop + $(this).outerHeight();

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              var currentId = $(this).attr("id");
              $(".navCommuniSec a").removeClass("active");
              $(".navCommuniSec a[href='#" + currentId + "']").addClass("active");
            }
        });
      }
    }
  }


  function scrollShowBtn() {
    if ($('.searchBlock').length) {
      var heightBtn = $('.searchBlock .btnSubmit').innerHeight(),
        offsetSearchBox = $('.searchBlock .btnSubmit').offset().top + heightBtn - headerHeight,
        offsetSearchBoxSp = $('.searchBlock .btnSubmit').offset().top + heightBtn,
        prevScroll = $(document).scrollTop();
      if ($('.searchBlock .searchBox').is(":visible")) {
        if (winWidth > 767) {
          if (prevScroll > offsetSearchBox && prevScroll < $('.contactSection').offset().top - headerHeight) {
            $('.jsShowBtn').fadeIn();
          } else {
            $('.jsShowBtn').fadeOut('fast');
          }
        } else {
          if (prevScroll > offsetSearchBoxSp && prevScroll < $('.contactSection').offset().top - headerHeight - $('.jsShowBtn a').outerHeight()) {
            $('.jsShowBtn').fadeIn();
          } else {
            $('.jsShowBtn').fadeOut('fast');
          }
        }
      }
    }
  }

  function handledSearch() {
    if ($('.searchBlock').length) {
      var urlSubmit = location.href;
      if (urlSubmit.indexOf('?condition') > -1) {
        $('.searchBox').show()
        $('.jsShowSearch').hide()
        if (winWidth > 767) {
          var offTop = $('#campusList').offset().top - headerHeight - 90;
          $('body, html').animate({
            scrollTop: offTop
          }, 500);
        } else {
          var offTop = $('#campusList').offset().top;
          $('body, html').animate({
            scrollTop: offTop - headerHeight - 9
          }, 500);
        }
      }
    }
  }
  handledSearch();

  let timerScroll,
    scrollBoxEls = document.querySelectorAll('.scrollShowBox');

  function showWhenScroll(el, offsetY) {
    if (el) {
      if (window.pageYOffset > offsetY) {
        el.classList.add('show');
      } else {
        el.classList.remove('show');
      }
    }
  }

  function initScrollBox() {
    if(scrollBoxEls.length > 0 && window.innerWidth < 768) {
      showWhenScroll(scrollBoxEls[0], 20);
    }
  }

  window.addEventListener('load', function () {
    scrollBoxEls = document.querySelectorAll('.scrollShowBox');
    initScrollBox();
  });

  function timeoutScroll() {
    initScrollBox();
  }

  $(window).on('scroll', function () {
    clearTimeout(timerScroll);
    timerScroll = setTimeout(timeoutScroll, 100);
  });

  $(window).on('load scroll resize', function() {
    scrollHeader();
    // changePos()
    scrollShowBtn();
    // scrollSidebar();
    scrollNavCommuni();
  })

  $(window).on('load', function() {

    $(".accordion").click(function(e) {
      if (!$(e.target).is('a')) {
        if (winWidth < 768) {
          var elm = $(this);
          if (elm.next(".accordionBox").is(":visible")) {
            elm.removeClass("active")
              .next(".accordionBox")
              .slideUp(200);
          } else {
            elm.next(".accordionBox").slideDown(200);
            elm.parents('.navItem').siblings().find('.accordionBox').slideUp(200);
            elm.parents('.navItem').siblings().find(".accordion").removeClass("active");
            elm.addClass("active");
          }
        }
      }
    });
    //$('.scrollShowBox').hide();

  })


  var topicSwiper = new Swiper('#topicSlider.swiper-container', {
    slidesPerView: 1,
    speed: 800,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: '.informationTopic .swiperPagination',
      type: 'custom',
      renderCustom: function(topicSwiper, current, total) {
        return current + '/' + total;
      }
    }
  });
  let _topicSlider = document.getElementById('topicSlider');
  if (_topicSlider) {
    let _sliderEle = _topicSlider.querySelectorAll('.swiper-slide'),
      _slideLength = _sliderEle.length;
    if (_slideLength < 4) {
      topicSwiper.destroy();
    }
  }

  if ($('select.formControl').length) {
    $('select.formControl').each(function() {
      if (!$(this).val()) {
        $(this).addClass('chooseDefault');
      } else {
        $(this).removeClass('chooseDefault');
      }
    })
    $(document).on('change', 'select.formControl', function() {
      if (!$(this).val()) {
        $(this).addClass('chooseDefault');
      } else {
        $(this).removeClass('chooseDefault');
      }
    });
  }

  $('#search_address').on('click', function() {
    if ($('.jsZipShow').val() != 'â€”') {
      $('.jsZipShow').removeClass('chooseDefault');
    }
  })

  $('.contentType .btnType').on('click', function() {
    var contentType = $(this).parents('.contentType');
    if (!contentType.hasClass('active')) {
      contentType.addClass('active');
      $('.moreType a').text('閉じる');
    } else {
      contentType.removeClass('active');
      $('.moreType a').text('もっと見る');
    }
  });
});

var winWidth = $(window).width(),
  headerHeight = $('#header').outerHeight();
$(window).resize(function() {
  winWidth = $(window).width();
  headerHeight = $('#header').outerHeight();
});

function jsDirect() {
  $('.jsDirect').on('click', function() {
    $(this).parent('.campusFormBox').remove();
  })
}

function jsReset() {
  $('.jsReset').on('click', function(e) {
    e.preventDefault();
    $(this).parent('.btnSchool').removeClass('edit');
  })
}

function disabledBtn() {
  if ($('.jsDisabled').length) {
    $('.jsDisabled').on('click', function(e) {
      $(this).text('é¸æŠžä¸­').addClass('disabled')
    });
  }
}

function activeDepartmentTab(departmentTabEl) {
  for (var i = 0; i < departmentTabEl.length; i++) {
    departmentTabEl[i].classList.remove('current')
  }
}

function initDepartmentTab() {
  var departmentTabEl = document.querySelectorAll('.jsDepartmentTab');
  if (departmentTabEl.length) {
    for (var i = 0; i < departmentTabEl.length; i++) {
      departmentTabEl[i].addEventListener('click', function(event) {
        event.preventDefault();
        activeDepartmentTab(departmentTabEl);
        var carouselDepartmentEl = document.getElementById('jsCarouselDepartment');
        carouselDepartmentEl.dataset.type = this.dataset.type;
        this.classList.add('current');
      });
    }
  }
}

function activeCampusTab(campusTabEl) {
  for (var i = 0; i < campusTabEl.length; i++) {
    campusTabEl[i].classList.remove('current')
  }
}

function initCampusTab() {
  var campusTabEl = document.querySelectorAll('.jsCampusTab');
  if (campusTabEl.length) {
    for (var i = 0; i < campusTabEl.length; i++) {
      campusTabEl[i].addEventListener('click', function(event) {
        event.preventDefault();
        activeCampusTab(campusTabEl);
        this.classList.add('current');
      });
    }
  }
}

function activeParticipationTab(participationTabEl) {
  for (var i = 0; i < participationTabEl.length; i++) {
    participationTabEl[i].classList.remove('current')
  }
}

function initParticipationTab() {
  var participationTabEl = document.querySelectorAll('.jsParticipationTab');
  if (participationTabEl.length) {
    for (var i = 0; i < participationTabEl.length; i++) {
      participationTabEl[i].addEventListener('click', function(event) {
        event.preventDefault();
        activeParticipationTab(participationTabEl);
        this.classList.add('current');
      });
    }
  }
}


function activeCampusFormTab(campusFormTabEl) {
  for (var i = 0; i < campusFormTabEl.length; i++) {
    campusFormTabEl[i].classList.remove('current')
  }
}

function initCampusFormTab() {
  if ($('.jsCheckModal').length) {
    $('.jsCheckModal').each(function() {
      var campusFormTabEl = $(this).find('.jsCampusFormTab');
      if (campusFormTabEl.length) {
        for (var i = 0; i < campusFormTabEl.length; i++) {
          campusFormTabEl[i].addEventListener('click', function(event) {
            event.preventDefault();
            activeCampusFormTab(campusFormTabEl);
            this.classList.add('current');
            var campusFormEl = document.getElementById('jsCampusForm');
            if (campusFormEl != undefined) {
              campusFormEl.dataset.type = this.dataset.type;
            }
          });
        }
      }
    });
  } else {
    var campusFormTabEl = document.querySelectorAll('.jsCampusFormTab');
    if (campusFormTabEl.length) {
      for (var i = 0; i < campusFormTabEl.length; i++) {
        campusFormTabEl[i].addEventListener('click', function(event) {
          event.preventDefault();
          activeCampusFormTab(campusFormTabEl);
          this.classList.add('current');
          var campusFormEl = document.getElementById('jsCampusForm');
          if (campusFormEl != undefined) {
            campusFormEl.dataset.type = this.dataset.type;
          }
        });
      }
    }
  }
}

function activeCampusCard() {
  $(document).on('click', '.campusCard', function() {
    $(this).toggleClass('active');
    $(this).parents('.swiper-slide').siblings().find('.campusCard').removeClass('active');
  })
}

function initCarouselBanner() {
  var carouselBannerEl = document.getElementById('jsCarouselBanner');
  if (carouselBannerEl != null) {
    var carouselBanner = new Swiper('#jsCarouselBanner .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1,
      loopAdditionalSlides: 1,
      loop: true,
      pagination: {
        el: '.jsPag',
        clickable: true,
      },
      navigation: {
        nextEl: '#jsCarouselBanner .jsNext',
        prevEl: '#jsCarouselBanner .jsPrev',
      },
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 15,
          centeredSlides: false,
          initialSlide: 0,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        }
      },
    });
    let _sliderEle = carouselBannerEl.querySelectorAll('.swiper-slide'),
      _slideLength = _sliderEle.length;
        if (window.innerWidth < 768) {
          if (_slideLength < 4) {
            carouselBanner.destroy();
            carouselBannerEl.classList.add('disable');
          }
        }
        else {
          if (_slideLength < 9) {
            carouselBanner.destroy();
            carouselBannerEl.classList.add('disable');
          }
        }
  }
}

function initCarouselBanner1() {
  var carouselBannerEl = document.getElementById('jsCarouselBanner1');
  if (carouselBannerEl != null) {
    var carouselBanner = new Swiper('#jsCarouselBanner1 .swiper-container', {
      slidesPerView: "auto",
      loopAdditionalSlides: 1,
      loop: true,
      navigation: {
        nextEl: '#jsCarouselBanner1 .jsNext',
        prevEl: '#jsCarouselBanner1 .jsPrev',
      },
      autoplay: false,
      breakpoints: {
        320: {
          spaceBetween: 0,
          slidesPerView: 1,
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        1200: {
          spaceBetween: 20,
          slidesPerView: 5,
        }
      },
    });
  }
}

function activeCarouselTvArt(id) {
  id = '#' + id;
  if ($(id + ' .swiper-container .swiper-slide').length > 1) {
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: "auto",
      loopAdditionalSlides: 1,
      loop: true,
      centeredSlides: true,
      loadPrevNext: true,
      lazy: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      pagination: {
        el: id + ' .swiper-pagination',
        type: "fraction",
      },
      autoplay: false,
      breakpoints: {
        320: {
          spaceBetween: 10,
        },
        768: {
          spaceBetween: 20,
        }
      },
    });
  }
}

function initCarouselTvArt() {
  var carouselTvArt = document.querySelectorAll('.jsCarouselTvArt');
  if (carouselTvArt.length > 0) {
    for (var i = 0; i < carouselTvArt.length; i++) {
      activeCarouselTvArt(carouselTvArt[i].id);
    }
  }
}

function activeCarouselEquipment(id, el) {
  var slideEls = el.querySelectorAll('.swiper-slide');
  id = '#' + id;
  if (slideEls.length >= 1) {
    var swiperButtonBlockEls = el.querySelectorAll('.swiper-button-block');
    if(swiperButtonBlockEls.length > 0 && slideEls.length > 1) {
      swiperButtonBlockEls[0].classList.add('show');
    }
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: "auto",
      loopAdditionalSlides: 1,
      loop: slideEls.length > 1 ? true : false,
      centeredSlides: true,
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      pagination: {
        el: id + ' .swiper-pagination',
        type: "fraction",
      },
      autoplay: false,
      preloadImages: false,
      lazy: {
        threshold: 50,
        loadPrevNext: true,
        loadPrevNextAmount: 2,
      },
      watchSlidesVisibility: true,
      breakpoints: {
        320: {
          spaceBetween: 30,
        },
        768: {
          spaceBetween: 40,
        },
        1200: {
          spaceBetween: 80,
        }
      },
      on: {
        slideChangeTransitionStart: function() {
          $(id + ' .swiper-container .swiper-slide-active').addClass('animated');
        },
        slideChangeTransitionEnd: function() {
          $(id + ' .swiper-container .swiper-slide-active').removeClass('animated');
        }
      }
    });
  }
}

function initCarouselEquipment() {
  var carouselEquipment = document.querySelectorAll('.jsCarouselEquipment');
  if (carouselEquipment.length > 0) {
    for (var i = 0; i < carouselEquipment.length; i++) {
      activeCarouselEquipment(carouselEquipment[i].id, carouselEquipment[i]);
    }
  }
}

function activeCarouselPoint(id) {
  id = '#' + id;
  if ($(id + ' .swiper-container .swiper-slide').length > 1 && !$(id + ' .swiper-container').hasClass('swiper-container-initialized')) {
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: false,
      loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: id + ' .jsPagination',
        clickable: true,
      },
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      autoplay: false,
      on: {
        resize: function() {
          if (window.innerWidth < 768) {
            this.destroy();
          }
        }
      }
    });
  }
}

function activeCarouselPointAll(id) {
  id = '#' + id;
  if ($(id + ' .swiper-container .swiper-slide').length > 1) {
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: false,
      loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: id + ' .jsPagination',
        clickable: true,
      },
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      autoplay: false,
    });
  }
}

function activeCarouselPoint01(id) {
  id = '#' + id;
  var carouselPoint = new Swiper(id + ' .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 20,
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 2,
    pagination: {
      el: id + ' .jsPagination',
      clickable: true,
    },
    navigation: {
      nextEl: id + ' .jsNext',
      prevEl: id + ' .jsPrev',
    },
    autoplay: false,
  });
  if (winWidth < 768) {
    carouselPoint.removeSlide(0)
  }
}

function activeCarouselPoint02(id) {
  id = '#' + id;
  var carouselPoint = new Swiper(id + ' .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 20,
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 2,
    pagination: {
      el: id + ' .jsPagination',
      clickable: true,
    },
    navigation: {
      nextEl: id + ' .jsNext',
      prevEl: id + ' .jsPrev',
    },
    autoplay: false,
  });
}

function activeCarouselPointInfo(id) {
  id = '#' + id;
  var carouselPoint = new Swiper(id + ' .swiper-container', {
    slidesPerView: 3,
    spaceBetween: 20,
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 1,
    pagination: {
      el: id + ' .jsPagination',
      clickable: true,
    },
    navigation: {
      nextEl: id + ' .jsNext',
      prevEl: id + ' .jsPrev',
    },
    autoplay: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      }
    },
  });
}

function activeCarouselPointInfo01(id) {
  id = '#' + id;
  var carouselPoint = new Swiper(id + ' .swiper-container', {
    slidesPerView: 2,
    spaceBetween: 10,
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 1,
    pagination: {
      el: id + ' .jsPagination',
      clickable: true,
    },
    navigation: {
      nextEl: id + ' .jsNext',
      prevEl: id + ' .jsPrev',
    },
    autoplay: false,
    on: {
      resize: function() {
        if (window.innerWidth < 768) {
          this.destroy();
        }
      }
    }
  });
}

function activeCarouselPointInfo02(id) {
  id = '#' + id;
  var carouselPoint = new Swiper(id + ' .swiper-container', {
    slidesPerView: 4,
    spaceBetween: 20,
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 1,
    pagination: {
      el: id + ' .jsPagination',
      clickable: true,
    },
    navigation: {
      nextEl: id + ' .jsNext',
      prevEl: id + ' .jsPrev',
    },
    autoplay: false,
    breakpoints: {
      320: {
        slidesPerView: 2,
      },
      768: {
        spaceBetween: 10,
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      }
    },
  });
}

function activeCarouselPointSp(id) {
  id = '#' + id;
  let container = $(id + ' .swiper-container');
  if (container.find('.swiper-slide').length > 1 && !container.hasClass('swiper-container-initialized')) {
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: 2,
      spaceBetween: 15,
      centeredSlides: true,
      initialSlide: 0,
      autoHeight: false,
      slidesPerView: 'auto',
      loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: id + ' .jsPag01',
        clickable: true,
      },
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      autoplay: false,
      on: {
        init: function() {
          $(id).addClass('active');
        },
        resize: function() {
          if (window.innerWidth > 767) {
            this.destroy();
          }
        },
      }
    });
  }
}

function activeCarouselPointInfoSp(id) {
  id = '#' + id;
  let container = $(id + ' .swiper-container');
  if (container.find('.swiper-slide').length > 1 && !container.hasClass('swiper-container-initialized')) {
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: 2,
      spaceBetween: 10,
      centeredSlides: false,
      autoHeight: false,
      loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: id + ' .jsPag01',
        clickable: true,
      },
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      autoplay: false,
      on: {
        resize: function() {
          if (window.innerWidth > 767) {
            this.destroy();
          }
        }
      }
    });
  }
}

function activeCarouselPointInfoSp01(id) {
  id = '#' + id;
  let container = $(id + ' .swiper-container');
  if (container.find('.swiper-slide').length > 1 && !container.hasClass('swiper-container-initialized')) {
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: 1,
      centeredSlides: true,
      initialSlide: 0,
      autoHeight: false,
      slidesPerView: 'auto',
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      on: {
        resize: function() {
          if (window.innerWidth > 767) {
            this.destroy();
          }
        }
      },
      autoplay: false,
    });
  }
}

function activeCarouselDocSp(id) {
  id = '#' + id;
  var carouselPoint = new Swiper(id + ' .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: false,
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 1,
    navigation: {
      nextEl: id + ' .jsNext',
      prevEl: id + ' .jsPrev',
    },
    autoplay: false,
    on: {
      resize: function() {
        if (window.innerWidth > 767) {
          this.destroy();
        }
      }
    }
  });
}

function aboutCarousel() {
  if ($('#jsAboutCarousel .swiper-container').length) {
    var aboutCarousel = new Swiper('#jsAboutCarousel .swiper-container', {
      spaceBetween: 0,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      freeMode: true,
      loop: true,
      loopFillGroupWithBlank: true,
      speed: 8000,
      loopAdditionalSlides: 1,
      autoHeight: false,
      freeModeMomentum: false,
      allowTouchMove: false,
      autoplay: {
        delay: 0.1,
        disableOnInteraction: false,
      },
    });
  }
}

function activeCarouselVid(id) {
  id = '#' + id;
  if ($(id + ' .swiper-container .swiper-slide').length > 2) {
    var carouselVid = new Swiper(id + ' .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 40,
      centeredSlides: false,
      loop: true,
      loopAdditionalSlides: 1,
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      autoplay: false,
      breakpoints: {
        320: {
          slidesPerView: 'auto',
          spaceBetween: 15,
          centeredSlides: true,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
          centeredSlides: false,
        }
      },
    });
  }
}

function activeCarouselVid01(id) {
  id = '#' + id;
  if ($(id + ' .swiper-container .swiper-slide').length > 2) {
    var carouselVid = new Swiper(id + ' .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 40,
      centeredSlides: false,
      loop: true,
      loopAdditionalSlides: 1,
      pagination: {
        el: id + ' .jsPagination',
        clickable: true,
      },
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      autoplay: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
          centeredSlides: false,
        }
      },
    });
  }
}

function activeCarouselInstructor(id) {
  id = '#' + id;
  let container = $(id + ' .swiper-container');
  if (container.find('.swiper-slide').length > 1 && !container.hasClass('swiper-container-initialized')) {
    var carouselPoint = new Swiper(id + ' .swiper-container', {
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 20,
      navigation: {
        nextEl: id + ' .jsNext',
        prevEl: id + ' .jsPrev',
      },
      on: {
        resize: function() {
          if (window.innerWidth < 768) {
            this.destroy();
          }
        }
      }
    });
  }
}

function activeCarouselEnta(id) {
  id = '#' + id;
  var carouselPoint = new Swiper(id + ' .swiper-container', {
    slidesPerView: 1,
    autoHeight: false,
    centeredSlides: false,
    loop: true,
    loopAdditionalSlides: 1,
    pagination: {
      el: id + ' .jsPagination',
      clickable: true,
    },
    navigation: {
      nextEl: id + ' .jsNext',
      prevEl: id + ' .jsPrev',
    },
    autoplay: false,
    breakpoints: {
      320: {
        slidesPerView: 'auto',
        spaceBetween: 8,
        centeredSlides: true,
      },
      768: {
        spaceBetween: 0,
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
  });
}

function activeCarouselEvent(id) {
  id = '#' + id;
  var carouselEvent = new Swiper(id + ' .swiper-container', {
    slidesPerView: 4,
    spaceBetween: 40,
    loop: true,
    // loopAdditionalSlides: 1,
    // loopFillGroupWithBlank: true,
    speed: 3000,
    autoplay: {
        delay: 0,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
        stopOnLastSlide: false,
        waitForTransition: true,
    },
    allowTouchMove: false,
    freeMode: true,
    freeModeMomentum: false,
    breakpoints: {
      320: {
        centeredSlides: true,
        // slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        centeredSlides: false,
        // slidesPerGroup: 6,
        slidesPerView: 4,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });
}

function initCarouselInstructor() {
  var carouselInstructor = document.querySelectorAll('.jsCarouselInstructor');
  if (carouselInstructor.length > 0) {
    for (var i = 0; i < carouselInstructor.length; i++) {
      activeCarouselInstructor(carouselInstructor[i].id);
    }
  }
}

function initCarouselPoint() {
  var carouselPoints = document.querySelectorAll('.jsCarouselPoint');
  if (carouselPoints.length > 0) {
    for (var i = 0; i < carouselPoints.length; i++) {
      activeCarouselPoint(carouselPoints[i].id);
    }
  }
}

function initCarouselPointAll() {
  var carouselPointsAll = document.querySelectorAll('.jsCarouselPointAll');
  if (carouselPointsAll.length > 0) {
    for (var i = 0; i < carouselPointsAll.length; i++) {
      activeCarouselPointAll(carouselPointsAll[i].id);
    }
  }
}

function initCarouselPoint01() {
  var carouselPoints01 = document.querySelectorAll('.jsCarouselPoint01');
  if (carouselPoints01.length > 0) {
    for (var i = 0; i < carouselPoints01.length; i++) {
      activeCarouselPoint01(carouselPoints01[i].id);
    }
  }
}

function initCarouselPoint02() {
  var carouselPoints01 = document.querySelectorAll('.jsCarouselPoint02');
  if (carouselPoints01.length > 0) {
    for (var i = 0; i < carouselPoints01.length; i++) {
      activeCarouselPoint02(carouselPoints01[i].id);
    }
  }
}

function initCarouselPointInfo() {
  var carouselPointsInfo = document.querySelectorAll('.jsCarouselPointInfo');
  if (carouselPointsInfo.length > 0) {
    for (var i = 0; i < carouselPointsInfo.length; i++) {
      activeCarouselPointInfo(carouselPointsInfo[i].id);
    }
  }
}

function initCarouselPointInfo01() {
  var carouselPointsInfo01 = document.querySelectorAll('.jsCarouselPointInfo01');
  if (carouselPointsInfo01.length > 0) {
    for (var i = 0; i < carouselPointsInfo01.length; i++) {
      activeCarouselPointInfo01(carouselPointsInfo01[i].id);
    }
  }
}

function initCarouselPointInfo02() {
  var carouselPointsInfo01 = document.querySelectorAll('.jsCarouselPointInfo02');
  if (carouselPointsInfo01.length > 0) {
    for (var i = 0; i < carouselPointsInfo01.length; i++) {
      activeCarouselPointInfo02(carouselPointsInfo01[i].id);
    }
  }
}

function initCarouselSp() {
  var carouselSp = document.querySelectorAll('.jsCarouselSp');
  if (carouselSp.length > 0) {
    for (var i = 0; i < carouselSp.length; i++) {
      activeCarouselPointSp(carouselSp[i].id);
    }
  }
}

function initCarouselPointSp() {
  var carouselPointsSp = document.querySelectorAll('.jsCarouselPointSp');
  if (carouselPointsSp.length > 0) {
    for (var i = 0; i < carouselPointsSp.length; i++) {
      activeCarouselPointInfoSp(carouselPointsSp[i].id);
    }
  }
}

function initCarouselDocSp() {
  var carouselDocSp = document.querySelectorAll('.jsCarouselDocSp');
  if (carouselDocSp.length > 0) {
    for (var i = 0; i < carouselDocSp.length; i++) {
      activeCarouselDocSp(carouselDocSp[i].id);
    }
  }
}

function initCarouselVid() {
  var carouselVid = document.querySelectorAll('.jsVidCarousel');
  if (carouselVid.length > 0) {
    for (var i = 0; i < carouselVid.length; i++) {
      activeCarouselVid(carouselVid[i].id);
    }
  }
}

function initCarouselVid01() {
  var carouselVid01 = document.querySelectorAll('.jsVidCarousel01');
  if (carouselVid01.length > 0) {
    for (var i = 0; i < carouselVid01.length; i++) {
      activeCarouselVid01(carouselVid01[i].id);
    }
  }
}

function initCarouselPointSp01() {
  var carouselPointsSp01 = document.querySelectorAll('.jsCarouselPointSp01');
  if (carouselPointsSp01.length > 0) {
    for (var i = 0; i < carouselPointsSp01.length; i++) {
      activeCarouselPointInfoSp01(carouselPointsSp01[i].id);
    }
  }
}

function initCarouselEnta() {
  var carouselPointsInfo01 = document.querySelectorAll('.jsCarouselEnta');
  if (carouselPointsInfo01.length > 0) {
    for (var i = 0; i < carouselPointsInfo01.length; i++) {
      activeCarouselEnta(carouselPointsInfo01[i].id);
    }
  }
}

function initCarouselEvent() {
  var carouselEvent = document.querySelectorAll('.jsCarouseEvent');
  if (carouselEvent.length > 0) {
    for (var i = 0; i < carouselEvent.length; i++) {
      activeCarouselEvent(carouselEvent[i].id);
    }
  }
}

function readMore() {
  $('.jsReadMore').on('click', function() {
    $(this).prev().addClass('show');
    $(this).remove();
  })
}

function limitText() {
  $('.jsLimit').each(function() {
    var $this = $(this);
    var txtHeight = $this.height();
    if (txtHeight < 47) {
      $this.next('.jsReadMore').hide();
      $this.addClass('rmShadow');
    } else {
      $this.next('.jsReadMore').show();
      $this.removeClass('rmShadow');
    }
  })
  $('.jsLimit01').each(function() {
    var $this = $(this);
    var txtHeight = $this.height();
    if (txtHeight < 37) {
      $this.next('.jsReadMore').hide();
      $this.addClass('rmShadow');
    } else {
      $this.next('.jsReadMore').show();
      $this.removeClass('rmShadow');
    }
  })
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

$(window).on('load', function(e) {
  $(".jsAccordion").click(function(e) {
    var elm = $(this);
    if (elm.next(".jsAccordionBox").is(":visible")) {
      elm.removeClass("active")
        .next(".jsAccordionBox")
        .slideUp(200);
    } else {
      elm.next(".jsAccordionBox").slideDown(200);
      elm.addClass("active");
    }
    e.preventDefault();
  });
  if ($('.firstView').length) {
    $('#contents').css('padding-top', window.innerHeight - $('.noteBox').outerHeight() - 30);
  }
  //
  var myhash = '#' + getParameterByName('anc', window.location);
  var tabHash = '#' + getParameterByName('tab', window.location);
  if (myhash != '#' && $(myhash).length > 0) {
    var offTop = $(myhash).offset().top - $('#header').outerHeight();
    if($('.pageTopFaq').length) {
      var offTop = $(myhash).offset().top - $('#header').outerHeight() - $('.faqSearchBox').outerHeight() - 5;
    }
    $('body, html').animate({
      scrollTop: offTop
    }, 500);
    e.preventDefault();
  }
  if (tabHash != '#' && $(tabHash).length > 0) {
    $('.tab01').find('a[href="' + tabHash + '"]').trigger('click');
    $('.jsNavTab').find('a[data-id="' + tabHash + '"]').trigger('click');
  }
})
$(window).on('load', function(e) {
  var myhash01 = location.hash;
  if (myhash01 != '#' && !myhash01.includes('#') && !myhash01.includes('?') && !myhash01.includes('=') && $(myhash01).length > 0)
  {
      var offTop = $(myhash01).offset().top - $('#header').outerHeight() - 20;
      $('body, html').animate({
        scrollTop: offTop
      }, 500);
      e.preventDefault();
  }
});
$(window).on('load resize', function(e) {
  if ($('.firstView .keyv').length) {
    $('.headerKeyvBox').height(window.innerHeight);
  }
  if ($(window).width() < 768) {
    var objClass = ['Announce', 'Toho', 'Movie', 'Onkyo']
    objClass.forEach(addClassNav);
  }
});

function addClassNav(value, index, array) {
  var classSchool = '.l' + value,
    classNav = '.navFt' + value;
  if ($(classSchool).length) {
    $(classNav).find('.accordion').addClass('active');
    $(classNav).find('.accordionBox').show();
  }
}

function loadMore() {
  const width =  $(window).width()
  // mobile
  if(width < 768)
  {
      if ($('.jsLoadMore > *').length > 11) {
          $('.jsLoadMore > *:gt(9)').hide();
          $('.jsBtnMore').show();
      }
  }
  // PC
  else{
      if ($('.jsLoadMore > *').length > 13) {
          $('.jsLoadMore > *:gt(11)').hide();
          $('.jsBtnMore').show();
      }
  }
$('.jsBtnMore a').on('click', function(e) {
  // mobile
  if(width < 768){
      $('.jsLoadMore > *:gt(9)').show();
  }
  // pc
  {
      $('.jsLoadMore > *:gt(11)').show();
  }
  var contentH = $('.jsLoadMore').height(),
  el = $(this),
  parentEl = el.parents('.jsLoadMore');
  $(window).resize(function() {
  contentH = $('.jsLoadMore').height();
  });
  $('html,body').animate({
  scrollTop: parentEl.offset().top + contentH - $(window).height() + 150
  }, 500);
  el.parent('.jsBtnMore').hide();
  e.preventDefault();
});
  }

function loadMore02() {
  if ($('.jsLoadMore02 > *').length > 8) {
    $('.jsBtnMore02').on('click', function(e) {
      $(this).hide();
      $('.jsLoadMore02 > *:gt(7)').removeClass('hide');
      $('.jsLoadMore02 > *:gt(7)').addClass('showItem');
      e.preventDefault();
    });
  }
}

function imageBiggerlink() {
  let imageEles = document.querySelectorAll('.newBlock .image');
  if (imageEles) {
    let imageElesLength = imageEles.length;
    for (let i = 0; i < imageElesLength; i++) {
      imageEles[i].addEventListener('click', function() {
        let imageEle = this,
          nextEle = imageEle.nextElementSibling,
          newTitle = nextEle.querySelector('.newTitle');
        newTitle.click();
      });
    }
  }
}

window.addEventListener('load', function(e) {
  let jsRightClicks = document.querySelectorAll('.jsRightClick');
  let ieCheck = /msie|Trident.*rv[ :]*11\./gi.test(window.navigator.userAgent);

  if (jsRightClicks) {
    let jsRightClickLength = jsRightClicks.length;
    for (let j = 0; j < jsRightClickLength; j++) {
      let images = jsRightClicks[j].querySelectorAll('.image');
      let imagesLength = images.length;
      for (let i = 0; i < imagesLength; i++) {
        images[i].oncontextmenu = new Function("return false");
      }
    }
  }
  $('img.protect').each(function() {
    $(this).after('<img class="blankImage" src="/assets/img/common/blank.gif">');
  });

  if (ieCheck) {
    let list = document.querySelectorAll('.jsObjectFitIE');
    if (list != null) {
      let lengthList = list.length;
      for (let k = 0; k < lengthList; k++) {
        list[k].classList.add("isIE");
        let linkImg = list[k].querySelector('img').src;
        list[k].style.backgroundImage = 'url(' + linkImg + ')';
      }
    }
  }
});


function imageProtect() {
  $('img.protect').each(function() {
    var h = $(this).height();
    var w = $(this).width();
    var img = $(this).parent().find('.blankImage');
    img.css({
      width: w,
      height: h
    });
  });
}

function checkCountItem() {
  $('.jsCheckCount').each(function() {
    var inputCount = $(this).find('.inputItem').length;
    if (inputCount % 2 == 0) {
      $(this).addClass('rmEven');
    } else {
      $(this).addClass('rmOdd');
    }
  });
}

function loadingScreen() {
  if ($('.searchBlock').length) {
    $('.loadingScreen').removeClass('showLoading');
    $('.jsLoading').click(function() {
      $('.loadingScreen').addClass('showLoading');
    })
  }
}

var position = $(window).scrollTop();

function scrollSidebar() {
  if ($('.jsFixed01').length) {
    if ($(window).width() < 768) {
      var mainOffset = $('main').offset().top - 20,
        prevScroll = $(document).scrollTop();

      if (prevScroll > position) {
        $('.jsFixed01').removeClass('scrollUp').addClass('scrollDown');
      } else {
        $('.jsFixed01').removeClass('scrollDown').addClass('scrollUp');
      }
      position = prevScroll <= 0 ? 0 : prevScroll; // For Mobile or negative scrolling

      if (prevScroll < mainOffset) {
        $('.jsFixed01').addClass('keepVisible');
        $('.contentFlex').addClass('relativeSp');
      } else {
        $('.jsFixed01').removeClass('keepVisible');
        $('.contentFlex').removeClass('relativeSp');
      }
    }
  }
}
// js carousel sideber sp
function carouselSidebarSp() {
  var carouselSidebar = document.getElementById('jsSidebarSp');
  if (carouselSidebar != null) {
    var carouselPoint = new Swiper('#jsSidebarSp .swiper-container', {
      slidesPerView: 'auto',
      on: {
        resize: function() {
          if (window.innerWidth > 767) {
            this.destroy();
          }
        }
      }
    });
    carouselPoint.slideTo(getSlideIndexByClass('active'));
  }
}

function getSlideIndexByClass(className) {
  var index = 0;
  $.each($('#jsSidebarSp .navSidebar').children(), function(i, item) {
    if ($(item).hasClass(className)) {
      index = i;
      return false;
    }
  });
  return index;
}

function checkActiveSidebar() {
  var itemSide = $('.navSidebar').children().find('a'),
    locationPath = window.location.href,
    locationPath01 = locationPath.replace(/\//g, '');
  itemSide.each(function() {
    var href = $(this).attr('href'),
      hrefActive = href.replace(/\//g, '');
    if (hrefActive == locationPath01) {
      $(this).parents('.item').addClass('active');
    }
  });
}

function checkActiveOverviewNav() {
  var itemNav = $('.navGroup').find('a'),
    locationPath = window.location.pathname,
    locationPath01 = locationPath.replace(/\//g, '');
  itemNav.each(function() {
    var href = $(this).attr('href'),
      hrefActive = href.replace(/\//g, '');
    if (hrefActive == locationPath01) {
      $(this).addClass('active jsPageTop');
    }
  });
}

function jsActiveLang() {
  var hostName = window.location.hostname,
    iconLang = $('.jsActiveLang').find('.iconLang');
  if (hostName.indexOf('k.agn') > -1) {
    iconLang.text('KR')
  } else if (hostName.indexOf('t.agn') > -1) {
    iconLang.text('CH')
  } else if (hostName.indexOf('c.agn') > -1) {
    iconLang.text('CHK')
  } else if (hostName.indexOf('s.agn') > -1) {
    iconLang.text('ES')
  } else if (hostName.indexOf('f.agn') > -1) {
    iconLang.text('FR')
  } else if (hostName.indexOf('e.agn') > -1) {
    iconLang.text('EN')
  } else if (hostName.indexOf('id.agn') > -1) {
    iconLang.text('ID')
  } else if (hostName.indexOf('th.agn') > -1) {
    iconLang.text('TH')
  } else if (hostName.indexOf('v.agn') > -1) {
    iconLang.text('VN')
  } else if (hostName.indexOf('.agn.hp') === -1) {
    iconLang.text('JP')
  }
}


function effectButton() {
  $('.button--bubble').each(function() {
    var $circlesTopLeft = $(this).parent().find('.circle.top-left');
    var $circlesBottomRight = $(this).parent().find('.circle.bottom-right');

    var tl = new TimelineLite();
    var tl2 = new TimelineLite();

    var btTl = new TimelineLite({ paused: true });

    tl.to($circlesTopLeft, 1.2, { x: -25, y: -25, scaleY: 2, ease: SlowMo.ease.config(0.1, 0.7, false) });
    tl.to($circlesTopLeft.eq(0), 0.1, { scale: 0.2, x: '+=6', y: '-=2' });
    tl.to($circlesTopLeft.eq(1), 0.1, { scaleX: 1, scaleY: 0.8, x: '-=10', y: '-=7' }, '-=0.1');
    tl.to($circlesTopLeft.eq(2), 0.1, { scale: 0.2, x: '-=15', y: '+=6' }, '-=0.1');
    tl.to($circlesTopLeft.eq(0), 1, { scale: 0, x: '-=5', y: '-=15', opacity: 0 });
    tl.to($circlesTopLeft.eq(1), 1, { scaleX: 0.4, scaleY: 0.4, x: '-=10', y: '-=10', opacity: 0 }, '-=1');
    tl.to($circlesTopLeft.eq(2), 1, { scale: 0, x: '-=15', y: '+=5', opacity: 0 }, '-=1');

    var tlBt1 = new TimelineLite();
    var tlBt2 = new TimelineLite();

    tlBt1.set($circlesTopLeft, { x: 0, y: 0, rotation: -45 });
    tlBt1.add(tl);

    tl2.set($circlesBottomRight, { x: 0, y: 0 });
    tl2.to($circlesBottomRight, 1.1, { x: 30, y: 30, ease: SlowMo.ease.config(0.1, 0.7, false) });
    tl2.to($circlesBottomRight.eq(0), 0.1, { scale: 0.2, x: '-=6', y: '+=3' });
    tl2.to($circlesBottomRight.eq(1), 0.1, { scale: 0.8, x: '+=7', y: '+=3' }, '-=0.1');
    tl2.to($circlesBottomRight.eq(2), 0.1, { scale: 0.2, x: '+=15', y: '-=6' }, '-=0.2');
    tl2.to($circlesBottomRight.eq(0), 1, { scale: 0, x: '+=5', y: '+=15', opacity: 0 });
    tl2.to($circlesBottomRight.eq(1), 1, { scale: 0.4, x: '+=7', y: '+=7', opacity: 0 }, '-=1');
    tl2.to($circlesBottomRight.eq(2), 1, { scale: 0, x: '+=15', y: '-=5', opacity: 0 }, '-=1');

    tlBt2.set($circlesBottomRight, { x: 0, y: 0, rotation: 45 });
    tlBt2.add(tl2);

    btTl.add(tlBt1);
    btTl.to($(this).parent().find('.button.effect-button'), 0.8, { scaleY: 1.1 }, 0.1);
    btTl.add(tlBt2, 0.2);
    btTl.to($(this).parent().find('.button.effect-button'), 1.8, { scale: 1, ease: Elastic.easeOut.config(1.2, 0.4) }, 1.2);

    btTl.timeScale(2.6);

    $(this).on('mouseover', function() {
      btTl.restart();
    });
  });
}

// keyv EntryGuide page
var keyvEntryGuideTimer;
const elmKeyvEntryGuide = $('.jsKeyvEntryGuide');

function isExistElm(elm) {
  if (elm) {
    return true;
  } else {
    return false;
  }
}

function keyvEntryGuide(isClear = false) {
  let slidesPerView = 2,
    duration = 3000,
    speed = 500;

  if (isClear) {
    clearInterval(keyvEntryGuideTimer);
    keyvEntryGuideTimer = null;
  } else {
    let slides = elmKeyvEntryGuide.find('.boxImg');
    let sLength = slides.length;
    let sLast = 0,
      i = slidesPerView;

    keyvEntryGuideTimer = setInterval(function() {
      $(slides[i]).fadeIn(speed);
      $(slides[sLast]).fadeOut(speed);

      i++;
      if (i == sLength) {
        i = 0;
      }
      sLast = i - slidesPerView;
      if (sLast < 0) {
        sLast = sLength + sLast;
      }
    }, duration);
  }
} // end keyvEntryGuide func\

function stickyTbl() {
  $('.jsStickyTbl').each(function (index) {
    const $this = $(this);
    const $rootTbl = $this.find('table');

    if ($this.data('cloned')) return;

    const $cloneTbl = $rootTbl.clone();
    const $wrapSticky = $this.closest('.wrapSticky');

    const $wrapTblClone = $('<div class="wrapTblClone"></div>');
    $wrapTblClone.append($cloneTbl);
    $wrapSticky.append($wrapTblClone);

    $this.data('cloned', true);

    stickyTbl_SetWidth($rootTbl, $wrapTblClone);

    $(window).on(`resize.stickyTbl${index}`, function () {
      stickyTbl_SetWidth($rootTbl, $wrapTblClone);
    });
  });
}

function stickyTbl_SetWidth($rootTbl, $wrapTblClone) {
  const thWidth = $rootTbl.find('thead tr th:first-child').outerWidth() || 0;
  const tblWidth = $rootTbl.outerWidth() || 0;

  $wrapTblClone.width(thWidth + 1);
  $wrapTblClone.find('table').width(tblWidth);
}

// ytb player func
var videoId = '';
if ($('#pageHome').length) {
  if (winWidth > 767) {
    videoId = 'gkvCC4YVjpQ';
  } else {
    videoId = 'Q0s_3Oa7KY4';
  }
} else if ($('#pageToho').length) {
  if (winWidth > 767) {
    videoId = '7v1ZUUfYEjE';
  } else {
    videoId = 'R2JZVa3io3Q';
  }
} else if ($('#pageMovie').length) {
  if (winWidth > 767) {
    videoId = '3jUi-zxQQDc';
  } else {
    videoId = 'l4rpOEx_i7c';
  }
} else if ($('#pageAnnounce').length) {
  if (winWidth > 767) {
    videoId = '2764zQEjjIU';
  } else {
    videoId = '-bXfaw3wH8U';
  }
} else if ($('#pageOnkyo').length) {
  if (winWidth > 767) {
    videoId = 'aR7ta9xO2F4';
  } else {
    videoId = 'eEEuHuhph1U';
  }
}

// Show video keyv when loaded (fix iOS)
if ($('#pageHome').length) {
  var vidTopPc = document.getElementById("videoTopPc"),
    vidTopSp = document.getElementById("videoTopSp");

  if (winWidth > 767) {
    if(vidTopPc) {
      vidTopPc.addEventListener("loadeddata", function() {
        vidTopPc.parentElement.classList.add('is-loaded');
      });
    }
  } else {
    if(vidTopSp) {
      vidTopSp.addEventListener("loadeddata", function() {
        vidTopSp.parentElement.classList.add('is-loaded');
      });
    }
  }
}
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";

var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var yt = [],
videoSlideEls = document.querySelectorAll('#jsCarouselVideo .swiper-slide');
function onYouTubeIframeAPIReady(dataId) {

  var w = '100%',
      h = '100%';
  if(dataId) {
    var ytVideo = new YT.Player(dataId, {
        width: w,
        height: h,
        videoId: dataId,
        playerVars: {
          playlist: dataId,
          modestbranding: 1, // YouTubeロゴの非表示
          iv_load_policy: 3, // アノテーションの非表示
          fs: 0, //全画面表示ボタンの非表示
          loop: 1, //ループ
          autoplay: 1,
          enablejsapi: 1,
          widget_referrer: 1,
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange,
          'onError': function(event) {onPlayerError(event, dataId)},
        },
      }), state = true;

    yt.forEach(ytItem => {
      if(ytItem.id === dataId) {
        state = false;
      }
    });
    if(state) {
      yt.push({'id' : dataId, 'video': ytVideo});
    }
  }
}
function onPlayerReady(event) {
  event.target.mute();
  event.target.playVideo();

}
function onPlayerStateChange(event) {
  if (event.data === YT.PlayerState.ENDED) {
     event.target.playVideo();
  }
}
var status = true;
function onPlayerError(event, dataId) {
      if (status) {
        if (event.data === "150") {
          const elm = document.getElementById(dataId);
          if (elm) {
            elm.src = elm.src;
          }
        }
      }
   status = false;
};
function initCarouselVideo() {
  var carouselVideoEl = document.getElementById('jsCarouselVideo'),
  videoSlideEls = document.querySelectorAll('#jsCarouselVideo .swiper-slide');
    if (carouselVideoEl != null) {
    var carouselVideo = new Swiper('#jsCarouselVideo .swiper-container', {
      spaceBetween: 15,
      slidesPerView: 1,
      navigation: {
        nextEl: '#jsCarouselVideo .jsNext',
        prevEl: '#jsCarouselVideo .jsPrev',
      },
      breakpoints: {
        320: {
          spaceBetween: 0
        },
        769: {
          spaceBetween: 15
        }
      },
      on: {
        init: function() {
          var slideVideoEl = videoSlideEls[this.realIndex].querySelectorAll('.handledControlVid')[0];
          if(slideVideoEl) {
            onYouTubeIframeAPIReady(slideVideoEl.id);
          }
        },
        beforeTransitionStart: function() {
          yt.forEach(ytItem => {
            if(ytItem.video && ytItem.video.playVideo) {
              ytItem.video.pauseVideo();
            }
          });
        },
        slideChangeTransitionEnd: function() {
          var slideVideoEl = videoSlideEls[this.realIndex].querySelectorAll('.handledControlVid')[0];
          if(slideVideoEl) {
            status = true;
            onYouTubeIframeAPIReady(slideVideoEl.id);
            if(yt[this.realIndex] && yt[this.realIndex].video && yt[this.realIndex].video.playVideo) {
              yt[this.realIndex].video.playVideo();
              yt[this.realIndex].video.mute();
            }
          }
        }
      }
    });
  }
}
function initCarouselMulStudent() {
  var carouselVideoEl = document.getElementById('jsStuMulSlide');
    if (carouselVideoEl != null) {
      var thumbsSwiper = new Swiper(".studentSlidesThumb .swiper-container", {
        freeMode: true,
        loop: true,
        watchSlidesProgress: true,
        // watchSlidesVisibility: true,
        breakpoints: {
          320: {
            spaceBetween: 5,
            slidesPerView: 3,
          },
          768: {
            spaceBetween: 15,
            slidesPerView: 6,
          }
        },
      });
      var mainSwiper = new Swiper('.studentSlidesMain .swiper-container', {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        lazy: true,
        coverflowEffect: {
          rotate: -15,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        navigation: {
          nextEl: "#jsStuMulSlide .swiper-button-next",
          prevEl: "#jsStuMulSlide .swiper-button-prev",
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
        breakpoints: {
          320: {
            spaceBetween: 15,
            slidesPerView: 1.3,
          },
          500: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          768: {
            spaceBetween: 30,
            slidesPerView: 2.5,
          },
          1400: {
            spaceBetween: 15,
            slidesPerView: 3.5,
          }
        },
      });
    }
}

function activeCarouselFacility() {
  var carouselFacilityEl = document.querySelectorAll('.jsCarouseFacility');
  if (carouselFacilityEl != null) {
    var carouselPoint = new Swiper('.jsCarouseFacility .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 25,
      autoHeight: false,
      centeredSlides: false,
      loop: false,
      navigation: {
        nextEl: '.jsCarouseFacility .jsNext',
        prevEl: '.jsCarouseFacility .jsPrev',
      },
      autoplay: false,
    });
  }
}

//window event
window.addEventListener('load', function(e) {
  jsActiveLang();
  initDepartmentTab();
  initCampusFormTab();
  initCampusTab();
  initParticipationTab();
  initCarouselBanner();
  initCarouselBanner1();
  initCarouselEquipment();
  initCarouselTvArt();
  readMore();
  limitText();
  loadMore();
  loadMore02();
  activeCampusCard();
  imageBiggerlink();
  imageProtect();
  checkCountItem();
  loadingScreen();
  jsDirect();
  jsReset();
  disabledBtn();
  scrollSidebar();
  checkActiveSidebar();
  checkActiveOverviewNav();
  initCarouselPointInfo();
  initCarouselPointInfo02();
  initCarouselPoint01();
  initCarouselPoint02();
  initCarouselPointAll();
  initCarouselEnta();
  activeCarouselFacility();
  initCarouselEvent();
  aboutCarousel();
  initCarouselVid();
  initCarouselVid01();
  initCarouselVideo();
  initCarouselMulStudent();
  // onYouTubeIframeAPIReady();
  if ($('.jsStickyTbl').length) {
    stickyTbl();
  }

  if (window.innerWidth >= 768) {
    initCarouselPoint();
    effectButton();
    initCarouselInstructor();
    initCarouselPointInfo01();
    if (isExistElm) {
      keyvEntryGuide();
    }

  } else {
    initCarouselSp();
    initCarouselPointSp();
    initCarouselPointSp01();
    initCarouselDocSp();
    carouselSidebarSp();
  }
});

window.addEventListener('resize', function() {
  limitText();
  imageProtect();
  scrollSidebar()

  if (window.innerWidth >= 768) {
    initCarouselPoint();
    initCarouselInstructor();
    initCarouselPointInfo01();

    // re-init slider EntryGuide
    if (!keyvEntryGuideTimer && isExistElm) {
      keyvEntryGuide();
    }
  } else {
    initCarouselSp();
    initCarouselPointSp();
    initCarouselPointSp01();
    initCarouselDocSp();
    carouselSidebarSp();
    // destroy slider EntryGuide
    if (keyvEntryGuideTimer) {
      keyvEntryGuide(true);
    }
  }
});


window.addEventListener('scroll', function() {
  scrollSidebar();
  // showbtnGuide();
});

document.addEventListener('visibilitychange', function() {
  if (document.hidden) {
    // tab is now inactive
    if (isExistElm) {
      keyvEntryGuide(true);
    }
  } else {
    // tab is active again
    if (isExistElm && window.innerWidth >= 768) {
      keyvEntryGuide();
    }
  }
});
function initVideo() {
  let id = 'jsVideoPC';
  if(window.innerWidth < 768) {
    id = 'jsVideoSP';
  }
  const dom = document.getElementById(id);
  if(dom) {
    if(!dom.src) {
      dom.src = dom.dataset.src;
      dom.parentElement.load();
    }
  }
}
window.addEventListener('load', function () {
  initVideo();
});
let timeout;
window.addEventListener('resize', function () {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    initVideo();
  }, 300);
});

$(function() {
  let hoverTimer;

  function closeAllShowBox(except = null) {
    $('.jsShow .showBox').not(except).slideUp(200);
  }

  function isInsideJsShowOrShowBox(target) {
    return $(target).closest('.jsShow, .showBox').length > 0;
  }

  function isInputFocusedInShowBox() {
    return $('.jsShow .showBox input:focus, .jsShow .showBox textarea:focus').length > 0;
  }

  if (winWidth > 767) {
    $('.jsShow')
      .on('mouseenter', function() {
        clearTimeout(hoverTimer);
        const currentBox = $(this).find('.showBox');

        closeAllShowBox(currentBox);
        currentBox.stop(true, true).slideDown('fast');
      })
      .on('mouseleave', function(e) {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          if (e.relatedTarget && !isInsideJsShowOrShowBox(e.relatedTarget) && !isInputFocusedInShowBox()) {
            closeAllShowBox();
          }
        }, 100);
      });
  }

  $('.jsShow > .btnCircle').on('click', function(e) {
    if (winWidth < 768) {
      e.preventDefault();
      let elm = $(this);
      let showBox = elm.next(".showBox");

      if (showBox.is(":visible")) {
        showBox.slideUp(200);
      } else {
        closeAllShowBox();
        showBox.slideDown(200, function() {
          showBox.find('input, textarea').first().focus();
        });
      }
    }
  });

  $(document).on('mouseup', function(e) {
    if (!isInsideJsShowOrShowBox(e.target) && !isInputFocusedInShowBox()) {
      closeAllShowBox();
    }
  });
  closeAllShowBox();
});